import { render } from "./MsgBoxComponent.vue?vue&type=template&id=0a01458e"
import script from "./MsgBoxComponent.vue?vue&type=script&lang=js"
export * from "./MsgBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__